export const URL_SERVICE =
  process.env.ENVIRONMENT === "QA"
    ? "https://integracionesqa.comfama.com"
    : process.env.ENVIRONMENT === "PDN"
    ? "https://integraciones.comfama.com"
    : "https://integracionesdev.comfama.com"

export const URL_BACK =
  process.env.ENVIRONMENT === "QA"
    ? "https://gwigiwznnb.execute-api.us-east-1.amazonaws.com/qa/comfama"
    : process.env.ENVIRONMENT === "PDN"
    ? "https://r7ajkqmij4.execute-api.us-east-1.amazonaws.com/pdn/comfama"
    : "https://dp0o47rzc7.execute-api.us-east-1.amazonaws.com/dev/comfama"

export const URL_CONTACT =
  process.env.ENVIRONMENT === "QA"
    ? "https://gwigiwznnb.execute-api.us-east-1.amazonaws.com/qa/portalservicios/services/api/v1/"
    : process.env.ENVIRONMENT === "PDN"
    ? "https://r7ajkqmij4.execute-api.us-east-1.amazonaws.com/pdn/portalservicios/services/api/v1/"
    : "https://dp0o47rzc7.execute-api.us-east-1.amazonaws.com/dev/portalservicios/services/api/v1/"

export const URL_TEMPORAL_TOKEN =
  process.env.ENVIRONMENT === "QA"
    ? "https://gwigiwznnb.execute-api.us-east-1.amazonaws.com/qa/portalservicios/common/api/v1.0/"
    : "https://dp0o47rzc7.execute-api.us-east-1.amazonaws.com/dev/portalservicios/common/api/v1.0/"

export const URL_TAXES =
  process.env.ENVIRONMENT === "QA"
    ? "https://gwigiwznnb.execute-api.us-east-1.amazonaws.com/qa/portalservicios/impuestosretencion/api/v1/"
    : process.env.ENVIRONMENT === "PDN"
    ? "https://r7ajkqmij4.execute-api.us-east-1.amazonaws.com/pdn/portalservicios/impuestosretencion/api/v1/"
    : "https://dp0o47rzc7.execute-api.us-east-1.amazonaws.com/dev/portalservicios/impuestosretencion/api/v1/"

export const URL_EDUCATION =
  process.env.ENVIRONMENT === "QA"
    ? "https://gwigiwznnb.execute-api.us-east-1.amazonaws.com/qa/portalservicios/educacionasistencia/api/v1/"
    : process.env.ENVIRONMENT === "PDN"
    ? "https://r7ajkqmij4.execute-api.us-east-1.amazonaws.com/pdn/portalservicios/educacionasistencia/api/v1/"
    : "https://dp0o47rzc7.execute-api.us-east-1.amazonaws.com/dev/portalservicios/educacionasistencia/api/v1/"

export const CLIENT_ID =
  process.env.ENVIRONMENT !== "PDN"
    ? "AZVs1L6j92XXqh9HKt02Ao9Dv5iauguk"
    : "NdmWAWJJfcn84WaJW2XWoAPykq3333yi"
export const SECRET_ID =
  process.env.ENVIRONMENT !== "PDN" ? "yVaGYB2woMo49WRG" : "stAcQduiNgN7ZVA8"
export const REFRESH_TOKEN =
  process.env.ENVIRONMENT !== "PDN"
    ? "https://nol-dev.auth.us-east-1.amazoncognito.com/oauth2/token"
    : "https://nol-pdn.auth.us-east-1.amazoncognito.com/oauth2/token"

export const RECOMENDATION_COURSES_API =
  process.env.ENVIRONMENT !== "PDN"
    ? "https://fa-synapseanalytics-qa.azurewebsites.net/api/ActivoDigitalEmpresas"
    : "https://fa-synapseanalytics.azurewebsites.net/api/ActivoDigitalEmpresas"

export const RECOMENDATION_COURSES_CODE =
  process.env.ENVIRONMENT !== "PDN"
    ? "JomHprJqeWIPXeTRhqcEcbRyrigiSQvhCQ7y2MXXKxLbAzFunkmFJw=="
    : "weW6xMhZ18kUhaJFSOgz9Dp8LdiNzS6wIuvTQsR-wO1BAzFu79s-JQ=="

// Get ip Address
export const GET_IP_ADDRESS = "https://jsonip.com/"

export const URL_QANTY =
  process.env.ENVIRONMENT === "QA"
    ? "https://gwigiwznnb.execute-api.us-east-1.amazonaws.com/qa/portalservicios/qanty/api/v1"
    : process.env.ENVIRONMENT === "PDN"
    ? "https://r7ajkqmij4.execute-api.us-east-1.amazonaws.com/pdn/portalservicios/qanty/api/v1"
    : "https://dp0o47rzc7.execute-api.us-east-1.amazonaws.com/dev/portalservicios/qanty/api/v1"

export const STATE_CONTRIBUTOR_TOKEN_APIKEY =
  process.env.ENVIRONMENT === "PDN"
    ? "0TbgA4rpWBltwvTNpUjfNun6bSGVWO7E"
    : "IDe3lvNLnJSnCxQrxR9lnEXpnBqHwjro"

export const STATE_CONTRIBUTOR_APIKEY =
  process.env.ENVIRONMENT === "PDN"
    ? "64GLTiuHpLfcHlkWE4K09NZfhNMuyii82fpC5UT1"
    : "FoBlvFALyf6SYhyTrt72t6Z8yq21GSjm7gWSu8gQ"

export const STATE_ACCOUNT_PENSION_APIKEY =
  process.env.ENVIRONMENT === "QA"
    ? "FoBlvFALyf6SYhyTrt72t6Z8yq21GSjm7gWSu8gQ"
    : "VEruryKOYE8wg0Qmk1OjV8qtSsMBeZ2IaJYtBguP"

export const URL_STATE_CONTRIBUTOR =
  process.env.ENVIRONMENT === "PDN"
    ? "https://integraciones.comfama.com/sub/SUB-APO-GetExcelEstadoCuentaAporte/"
    : "https://integracionesqa.comfama.com/sub/SUB-APO-GetExcelEstadoCuentaAporte/"

export const URL_STATE_ACCOUNT_PENSION =
  process.env.ENVIRONMENT === "QA"
    ? "https://integracionesqa.comfama.com/sub/SUB-APO-GetExcelEstadoCuentaAporteIndependientePensionado/"
    : "https://integracionesdev.comfama.com/sub/SUB-APO-GetExcelEstadoCuentaAporteIndependientePensionado/"

export const URL_LEGAL =
  process.env.ENVIRONMENT === "PDN"
    ? "https://r7ajkqmij4.execute-api.us-east-1.amazonaws.com/pdn/comfama/portalservicioslegal/api/v1/legal"
    : "https://be48sfzilf.execute-api.us-east-1.amazonaws.com/dev/comfama/legal/api/v1/legal"

export const URL_VERIFICATOR_API =
  process.env.ENVIRONMENT === "QA"
    ? "https://lheeaqret8.execute-api.us-east-1.amazonaws.com/qa/"
    : process.env.ENVIRONMENT === "PDN"
    ? "https://566m5ujvu8.execute-api.us-east-1.amazonaws.com/pdn/"
    : "https://be48sfzilf.execute-api.us-east-1.amazonaws.com/dev/"

export const URL_ENTERPRISES_BILLS =
  process.env.ENVIRONMENT === "QA"
    ? "https://gwigiwznnb.execute-api.us-east-1.amazonaws.com/qa/portalservicios/pagofacturas/api/v1/"
    : process.env.ENVIRONMENT === "PDN"
    ? "https://r7ajkqmij4.execute-api.us-east-1.amazonaws.com/pdn/portalservicios/pagofacturas/api/v1/"
    : "https://dp0o47rzc7.execute-api.us-east-1.amazonaws.com/dev/portalservicios/pagofacturas/api/v1/"

export const CDC_APIKEY =
  process.env.ENVIRONMENT === "QA"
    ? "8cNuSOiY4g1yYbgc6UtnIaMD9NmTyrQE6MmASpsU"
    : process.env.ENVIRONMENT === "PDN"
    ? "OBSIRU0wEi8u1wmggx82l2jXB56X3DJy2rdajL6V"
    : "K66FGlC8lV4pPvcHbJ7Xr8rjjg2cmjRXaXYffYZq"

export const CDC_APIKEY_IDP =
  process.env.ENVIRONMENT === "QA"
    ? "hyLAEwGTUTWqiZrekI794FVh31oCKu22OtSH8FUf"
    : process.env.ENVIRONMENT === "PDN"
    ? "Q0OGOQjytF3sxqdWMLo1c57MMHISjdzvDmvwqAl7"
    : "ILWZ3MBQOg50Rgg3dbkgW4XDouDL3d5l8Da1Y28U"

export const APIKEY_EXPRESS_PAY =
  process.env.ENVIRONMENT === "PDN"
    ? "UFDiizsIt98tAl8Db4WTH4DbaRm02uIV6pJDx6yO"
    : process.env.ENVIRONMENT === "QA"
    ? "0WOZZjFs89JAtlWfVyfV4wXe0l98iwJ3EWLaj3lb"
    : "VHxL7KCONW1cgxUCeISx767G5YaAkHZd6XD9GK5A"

export const EXPRESS_PAYMENT_URL =
  process.env.ENVIRONMENT === "QA"
    ? "https://integracionesqa.comfama.com/sfin/SFIN-SEG-InformacionSeguroVoluntario/api/Express/"
    : process.env.ENVIRONMENT === "PDN"
    ? "https://integraciones.comfama.com/sfin/SFIN-SEG-InformacionSeguroVoluntario/api/Express/"
    : "https://integracionesdev.comfama.com/sfin/SFIN-SEG-InformacionSeguroVoluntario/api/Express/"

export const GIGYA_API_KEY =
  process.env.ENVIRONMENT === "QA"
    ? "3_gRpdLbyLjbFd6HeEXoJ-nQudIobjbhWrWkN4OdSL6o6JQUwsYyRjHFRKuUiopn6J"
    : process.env.ENVIRONMENT === "PDN"
    ? "3_NJAFyxKgkM4nkaHo9DEA0GLRa9UknapkBNWiRDcwm1RA1JUrHV4CXUBILVv2KHTH"
    : "3_gRpdLbyLjbFd6HeEXoJ-nQudIobjbhWrWkN4OdSL6o6JQUwsYyRjHFRKuUiopn6J"

export const COMPANY_NAME_URL =
  process.env.ENVIRONMENT === "PDN"
    ? "https://integraciones.comfama.com/delta/api/Company/GetCompanyName"
    : "https://integracionesqa.comfama.com/delta/api/Company/GetCompanyName"

export const COMPANY_NAME_API_KEY =
  process.env.ENVIRONMENT === "PDN"
    ? "dSuLsiDEpDzFczpYAwgz73rjmusN8Vm9lvgdC5Vi"
    : "k7sK4iexDE1CJv32AEtfO6bYyAldEphF3AXei2GN"